import { Controller } from "@hotwired/stimulus";

// When an international number (+353… or 00353…) is typed or pasted into
// the national input, select the matching country and strip the dial code.
export default class extends Controller {
  static targets = ["country", "number"];
  static values = { codes: Object };

  detect() {
    let value = this.numberTarget.value.trim();
    if (value.startsWith("00")) value = `+${value.slice(2)}`;
    if (!value.startsWith("+")) return;

    const digits = value.slice(1).replace(/\D/g, "");
    for (let length = Math.min(3, digits.length); length > 0; length--) {
      const country = this.codesValue[digits.slice(0, length)];
      if (country) {
        this.#selectCountry(country);
        this.numberTarget.value = digits.slice(length);
        return;
      }
    }
  }

  // The select may be enhanced by choices.js, which doesn't reflect
  // programmatic changes to the underlying select element.
  #selectCountry(country) {
    const choices = this.application.getControllerForElementAndIdentifier(
      this.countryTarget,
      "choices",
    );
    if (choices) {
      choices.setValue(country);
    } else {
      this.countryTarget.value = country;
    }
  }
}
